module.exports = __webpack_public_path__ + "img/quickrights-logo.da55a266.png";